import { render } from "./AuthenticatedFooter.vue?vue&type=template&id=2814c4a6"
import script from "./AuthenticatedFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticatedFooter.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticatedFooter.vue?vue&type=style&index=0&id=2814c4a6&scope=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/AuthenticatedFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2814c4a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2814c4a6', __exports__)) {
    console.log('reload')
    api.reload('2814c4a6', __exports__)
  }
  
  module.hot.accept("./AuthenticatedFooter.vue?vue&type=template&id=2814c4a6", () => {
    console.log('re-render')
    api.rerender('2814c4a6', render)
  })

}


export default __exports__